import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

// Moved to `importer`; also keeps `excel-importer` from being read as a quote request id.
export const Route = createFileRoute(
    '/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/excel-importer',
)({
    // Only redirects: the importer checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/negotiations/$negotiationId/quote-requests/importer',
            params: { negotiationId: params.negotiationId },
            search: true,
            replace: true,
        });
    },
});
